<template>
  <div class="search-wrapper" :class="{hidden: searchDisabled}">
    <div class="search-selectors" :class="{hidden: searchDisabled}">
      <div class="form-check form-check-inline search-radio-item">
        <input class="form-check-input" type="radio" id="searchName" value="fileName" v-model="searchType" checked>
        <label class="form-check-label" for="searchName">Search by File Name</label>
      </div>
      <div class="form-check form-check-inline search-radio-item">
        <input class="form-check-input" type="radio" id="searchHash" value="hash" v-model="searchType">
        <label class="form-check-label" for="searchHash">Search by Hash</label>
      </div>
      <div class="form-check form-check-inline search-radio-item">
        <input class="form-check-input" type="radio" id="searchVirus" value="avResponse" v-model="searchType">
        <label class="form-check-label" for="searchVirus">Search by Virus</label>
      </div>
    </div>

    <form class="search-box">
      <div class="form-group m-0">
        <input type="text" :disabled="searchDisabled" class="form-control search-bar" v-model="searchQuery" :placeholder="placeholderText"/>
        <img @click.prevent="toggleSearch" class="search-img" :class="{hidden: searchDisabled}">
      </div>
    </form>
  </div>
</template>
<!--Search by ...-->
<script>
export default {
  name: 'SearchHistory',
  data() {
    return {
      searchType: "fileName",
      searchQuery: "",
      placeholderText: "",
      searchDisabled: true,
    }
  },
  methods: {
    updateValue: function () {
      this.$emit('query', [this.searchQuery, this.searchType])
    },
    toggleSearch: function () {
      this.searchDisabled = !this.searchDisabled
      if (this.searchDisabled !== true) {
        this.placeholderText = "Search by ..."
      } else {
        this.placeholderText = ""
      }
    }
},
  watch: {
    searchQuery: {
      handler() {
        this.updateValue()
      }
    },
    searchType: {
      handler() {
        this.updateValue()
      }
    }
  }
}
</script>